import React from "react";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import { BsClockHistory } from "react-icons/bs";
import ReactGA from "react-ga4";

const legacyData = {
  DooChatDesc:
    "DooChat is a real-time chat and mini social media platform where users can send messages, images, and videos, add friends, and engage in one-on-one conversations. Built with Next.js for the frontend, Node.js for the backend, and styled using Shadcn UI.",
  DooChatGithub: "",
  DooChatWebsite: "https://doochat.io.vn/",
  DooChatTags: ["Next.js", "Node.js", "Shadcn UI", "Socket.io"],

  BookStoreDesc:
    "BookStore is an online book-selling website with two main sections: an admin panel for managing books, categories, and orders, and a client side where users can browse and purchase books. The project was built using ReactJS and Ant Design.",
  BookStoreGithub: "https://github.com/trungcrbay/React_ANTD_ECOMMERCE",
  BookStoreWebsite: "https://react-antd-ecommerce.vercel.app/",
  BookStoreTags: ["React", "Ant Design", "REST API"],

  QuizDesc:
    "QuizApp is an interactive quiz platform where users can take quizzes and receive scores based on their performance. The admin panel allows administrators to manage quizzes, questions, and users. The project was built using ReactJS and Material UI for a clean and responsive interface.",
  QuizGithub: "https://github.com/trungcrbay/QuizApp",
  QuizWebsite: "https://quiz-app-trungcrbay.vercel.app/",
  QuizTags: ["React", "Material UI", "JavaScript"],

  DooCommerceDesc:
    "DooCommerce is a full-featured e-commerce web application that allows users to browse products, add items to their cart, place orders, and manage their profiles. Admins can manage products, categories, orders, and users. The project was developed using Next.js for the frontend, NestJS for the backend, and PostgreSQL for the database.",
  DooCommerceGithub: "https://trungcrbay.io.vn/",
  DooCommerceWebsite: "",
  DooCommerceTags: ["Next.js", "NestJS", "PostgreSQL"],
};

const ProjectBox = ({
  projectPhoto,
  projectName,
  title,
  desc,
  image,
  tags,
  github,
  demo,
  status,
}) => {
  const displayTitle = title || projectName;
  const displayPhoto = image || projectPhoto;
  const displayDesc =
    desc || legacyData[projectName + "Desc"] || "";
  const displayGithub =
    github !== undefined ? github : legacyData[projectName + "Github"];
  const displayDemo =
    demo !== undefined ? demo : legacyData[projectName + "Website"];
  const displayTags =
    tags || legacyData[projectName + "Tags"] || [];
  const displayStatus =
    status || (displayTitle === "DooCommerce" ? "ongoing" : "live");

  const handleProjectClick = (type, url) => {
    if (!url) return;

    // Gửi sự kiện khi người dùng click vào project
    ReactGA.event({
      category: "Portfolio Interaction",
      action: "Project Click",
      label: `${displayTitle} - ${type}`,
      value: 1,
    });

    window.open(url, "_blank");
  };

  return (
    <div className="projectBox">
      <div className="projectImageContainer">
        <img
          className="projectPhoto"
          src={displayPhoto}
          alt={`${displayTitle} preview`}
          loading="lazy"
        />
        {displayStatus === "ongoing" ? (
          <span className="projectStatusBadge ongoing">
            <BsClockHistory /> Ongoing
          </span>
        ) : (
          <span className="projectStatusBadge live">
            <span className="liveDot"></span> Live
          </span>
        )}
      </div>

      <div className="projectContent">
        <h3 className="projectTitle">{displayTitle}</h3>
        <p className="projectDesc">{displayDesc}</p>

        {displayTags && displayTags.length > 0 && (
          <div className="projectTags">
            {displayTags.map((tag, index) => (
              <span key={index} className="projectTag">
                {tag}
              </span>
            ))}
          </div>
        )}

        <div className="projectButtons">
          {displayGithub ? (
            <button
              className="projectbtn githubBtn"
              onClick={() => handleProjectClick("Github", displayGithub)}
              title="View source code on GitHub"
            >
              <FaGithub /> GitHub
            </button>
          ) : (
            <button
              className="projectbtn githubBtn disabled"
              disabled
              title="Repository is private"
            >
              <FaGithub /> Private
            </button>
          )}

          {displayDemo ? (
            <button
              className="projectbtn demoBtn"
              onClick={() => handleProjectClick("Website", displayDemo)}
              title="Open live website demo"
            >
              <FaExternalLinkAlt /> Demo
            </button>
          ) : (
            <button
              className="projectbtn demoBtn disabled"
              disabled
              title="In active development"
            >
              <BsClockHistory /> In Dev
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectBox;
